import React from 'react';
import { flex } from '@fabric-ui/theme';
import useQueryObject from '@hooks/useQueryObjectSql';
import { Box, Skeleton, Typography } from '@mui/material';
import { keepPreviousData } from '@tanstack/react-query';
import { DwQueryRequest } from '../../CustomDashboards/types';
import { calculatePercentageChange, getNumericValue } from '../utils';
import { getTotalAlertsCountByAgents } from './queries';
import StatusChange from './statusChange';
import { getLast24HoursDate } from './utils';

const AgentStatus = ({ filterContext, totalAlertCount }) => {
  const last24HoursAlertCount = useQueryObject({
    queryObject: [
      getTotalAlertsCountByAgents({
        ...filterContext,
        dateRange: [getLast24HoursDate(filterContext.dateRange[1]), filterContext.dateRange[1]],
      }) as DwQueryRequest,
    ],
    options: { placeholderData: keepPreviousData },
    onSuccess: data => data?.[0]?.cnt,
  });

  const percentage = calculatePercentageChange(getNumericValue(last24HoursAlertCount.data), getNumericValue(totalAlertCount.data));

  return (
    <Box sx={{ padding: '16px 24px', background: 'var(--color-surface-base-primary)', minHeight: '137px', height: '100%', ...flex.col }}>
      <Typography sx={{ fontSize: '14px', marginBottom: '16px', color: 'var(--color-content-base-tertiary)' }} variant="h2">
        Alerts Investigated
      </Typography>
      {!totalAlertCount.isLoading && !totalAlertCount.isRefetching ? (
        <div>
          <Box display="flex" flexDirection="row" alignItems="baseline" gap="8px">
            <Typography variant="h3" sx={{ m: 0, fontSize: '24px', color: 'var(--color-content-base-primary)' }}>
              {Number(totalAlertCount?.data || 0).toLocaleString() ?? 0}
            </Typography>
            <Typography variant="body2" sx={{ fontSize: '13px', color: 'var(--color-content-base-primary)' }}>
              Total
            </Typography>
          </Box>
          <Box sx={{ ...flex.itemsCenter, gap: 1, lineHeight: '18px', marginTop: '8px' }}>
            <StatusChange value={percentage} />
            <Typography variant="body2" sx={{ fontSize: '13px', color: 'var(--color-content-base-subdued)' }}>
              Last 24 hours
            </Typography>
          </Box>
        </div>
      ) : (
        <Skeleton variant="rectangular" width="100%" height="100%" />
      )}
    </Box>
  );
};

export default AgentStatus;
